var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.disabled == false ? _vm.edit(): 1}}},[_c('feather-icon',{staticClass:"mr-2",style:(_vm.disabled == true ? 'color: lightgrey;': ''),attrs:{"icon":"EditIcon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }